import { Row, Col } from "antd";
import { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import banner01_desktop from "../assets/img_event_2025072901_banner_desktop.png";
import banner01_mobile from "../assets/img_event_2025072901_banner_mobile.png";
import banner02_desktop from "../assets/img_event_2025072902_banner_desktop.png";
import banner02_mobile from "../assets/img_event_2025072902_banner_mobile.png";
import { styled } from "styled-components";
import { indicatorRenderer } from "./Indicator";
import Link from "./Link";
import Slider from 'react-slick';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const HeaderCarouselWrapper = styled.div`
  position: "relative";

  .carousel-wrapper,
  .carousel,
  .carousel > .slider-wrapper,
  .carousel > .slider-wrapper > .slider {
    height: 100%;
  }

  .carousel-wrapper .carousel {
    overflow: visible;
  }

  .carousel-wrapper .carousel .control-dots {
    display: flex;
    justify-content: center;
    align-items: center;
    list-style-type: none;
    transform: translateY(40px);
  }

  .carousel-wrapper .carousel .control-dots li {
    margin: 0px 8px;
  }
`;
const CarouselItem = styled.div`
    display: flex !important;
    flex-direction: column;
    align-items: center;
`;

const CustomArrow = styled.div<{ style: React.CSSProperties }>`
    ${({ style }) => ({...style})}
    background-color: #45B9AE;
    width: 40px; 
    height: 40px;
    border-radius: 30px;
    text-align: center;
    font-size: 20px;
    color: #FFFFFF;
    display: flex !important;
    justify-content: center;
    align-items: center;
    z-index: 20;
    
    &:before {
        display: none; 
    }

    &:hover {
        color: #FFFFFF;
        background: #45B9AE;
    }
`;
const Header = () => {
    const [contentOpacity, setContentOpacity] = useState(0);
    const banners = [
        {
            desktop: {
                img: banner01_desktop,
                alt: "img_bg_desktop",
                style: {
                    width: "90vw",
                    position: "relative" as const,
                    maxWidth: "1200px",
                    padding: "20px 0px 32px",
                },
            },
            mobile: {
                img: banner01_mobile,
                alt: "img_bg_mobile",
                style: {
                    width: "100vw",
                    position: "relative" as const,
                    paddingTop: "20px",
                },
            },
            url: "https://www.surveycake.com/s/glOg2",
        },
        {
            desktop: {
                img: banner02_desktop,
                alt: "img_bg_desktop",
                style: {
                    width: "90vw",
                    position: "relative" as const,
                    maxWidth: "1200px",
                    padding: "20px 0px 32px",
                },
            },
            mobile: {
                img: banner02_mobile,
                alt: "img_bg_mobile",
                style: {
                    width: "100vw",
                    position: "relative" as const,
                    paddingTop: "20px",
                },
            },
            url: "https://www.surveycake.com/s/AOygA",
        },
    ];
        const PrevArrow = (props: {
        className?: string,
        onClick?: React.MouseEventHandler<HTMLDivElement>,
        style?: React.CSSProperties
    }) => (
        <CustomArrow className={props.className} onClick={props.onClick} style={{ ...props.style!, left: '15px' }} >
            <LeftOutlined/>
        </CustomArrow>
    );

    const NextArrow = (props: {
        className?: string,
        onClick?: React.MouseEventHandler<HTMLDivElement>,
        style?: React.CSSProperties
    }) => (
        <CustomArrow className={props.className} onClick={props.onClick} style={{ ...props.style!, right: '15px' }} >
            <RightOutlined/>
        </CustomArrow>
    );
    useEffect(() => {
        setTimeout(() => setContentOpacity(1), 500);
    }, []);
    return (
        <HeaderCarouselWrapper>
            <Slider
                    slidesToShow={1}
                    slidesToScroll={1}
                    infinite={true}
                    dots={true}
                    autoplay={true}
                    autoplaySpeed={2500}
                    prevArrow={<PrevArrow/>}
                    nextArrow={<NextArrow/>}
                >
                    {banners.map((banner, index) => (
                        <CarouselItem>
                            <Row key={index}>
                                <Link newTab={true} href={banner.url} style={{ width: "100%" }}>
                                    <Col
                                        lg={24}
                                        md={0}
                                        sm={0}
                                        xs={0}
                                        style={{ position: "relative", textAlign: "center" }}
                                    >
                                        <img
                                            src={banner.desktop.img}
                                            alt={banner.desktop.alt}
                                            style={banner.desktop.style}
                                        />
                                        <div
                                            style={{
                                                position: "absolute",
                                                left: "120px",
                                                top: "160px",
                                                opacity: contentOpacity,
                                                transition: "opacity 1s",
                                            }}
                                        ></div>
                                    </Col>
                                </Link>
                                <Link newTab={true} href={banner.url} style={{ width: "100%" }}>
                                    <Col
                                        lg={0}
                                        md={24}
                                        sm={24}
                                        xs={24}
                                        style={{ backgroundColor: "#ECF4FD" }}
                                    >
                                        <img
                                            src={banner.mobile.img}
                                            alt={banner.mobile.alt}
                                            style={banner.mobile.style}
                                        />
                                        <div
                                            style={{
                                                marginTop: "24px",
                                                textAlign: "center",
                                                opacity: contentOpacity,
                                                transition: "opacity 1s",
                                            }}
                                        ></div>
                                    </Col>
                                </Link>
                            </Row>
                        </CarouselItem>
                ))}
            </Slider>
        </HeaderCarouselWrapper>
    );
};

export default Header;
